import React from "react";
import Hero from "./home/Hero";
import ChooseUs from "./home/ChooseUs";
import Solution from "./home/Solution";
import ScrollingBanner from "./home/ScrollingBanner";
import ServicesPage from "./home/ExploreServices";
import TechIntegration from "./home/Integration";
import ClientSection from "./home/Testimonial";
import ContactSection from "./home/GetinTouch";
import ExploreProjectsHero from "./home/Projects";
import WorkingProcess from "./home/Working";
import BlogSection from "./home/BlogSection";

const Home = () => (
  <div className="overflow-hidden">
    <Hero />
    <Solution />
    <WorkingProcess />
    <ChooseUs />
    <div className="bg-black py-0">
      <ScrollingBanner
        items={[
          "Passion and progress",
          "Founders and vision",
          "Growth and impact",
          "Team and values",
        ]}
        separatorIcon="✱"
      />
    </div>
    <ServicesPage />
    <TechIntegration />
    <ExploreProjectsHero />
    <ClientSection />
    {/* <div className="bg-black py-0">
      <ScrollingBanner
        items={[
          "Passion and progress",
          "Founders and vision",
          "Growth and impact",
          "Team and values",
        ]}
        separatorIcon="✱"
      />
    </div> */}
   
    <ContactSection />
    {/* <Join /> */}
    <BlogSection />

    {/* <GradualBlur
      preset="page-footer"
      curve="bezier"
      exponential
      opacity={1}
      backgroundColor="rgba(255,255,255,0.08)"
    /> */}
  </div>
);

export default Home;
